import { Base } from '@studiometa/js-toolkit';
import Menu from './Menu.js';
import MenuMobile from './MenuMobile.js';

/**
 * Header component
 */
export default class Header extends Base {
  isSticky = false;

  /**
   * Component Configuration
   */
  static config = {
    name: 'Header',
    refs: ['wrapper'],
    components: {
      Menu,
      MenuMobile,
    },
  };

  /**
   *
   */
  mounted() {
    if (window.scrollY > 100) {
      document.body.classList.add('is-sticky');
    }
  }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   * @param {object} props.direction For both axis, whether or not the current position has changed since the last one.
   */
  scrolled({ y, direction }) {
    if (y > 150 && !this.isSticky) {
      document.body.classList.add('is-sticky');
      this.isSticky = true;
    }

    if (y < 50 && this.isSticky) {
      document.body.classList.remove('is-sticky');
      this.isSticky = false;
    }

    if (direction.y === 'NONE') {
      return;
    }

    if (y > 150) {
      if (direction.y === 'DOWN' && !document.body.classList.contains('menu-is-open')) {
        this.$el.classList.add('-top-full');
        this.$el.classList.remove('top-0');
      }
      if (direction.y === 'UP') {
        this.$el.classList.remove('-top-full');
        this.$el.classList.add('top-0');
      }
    }
  }
}
